import { render, staticRenderFns } from "./Fall.vue?vue&type=template&id=5f5ccf5e&scoped=true"
import script from "./Fall.vue?vue&type=script&lang=js"
export * from "./Fall.vue?vue&type=script&lang=js"
import style0 from "./Fall.vue?vue&type=style&index=0&id=5f5ccf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ccf5e",
  null
  
)

export default component.exports